export function urlMatches(url: string, path: string): boolean {
  if (!path) {
    return false;
  }
  const cleanUrl = url.split(/[?#]/)[0] ?? '';
  const cleanPath = path.split(/[?#]/)[0] ?? '';
  const normalized = cleanPath.startsWith('/') ? cleanPath : '/' + cleanPath;
  return cleanUrl === normalized || cleanUrl.startsWith(normalized + '/');
}
